import Axios from 'axios';
import { Observable } from 'rxjs/Observable';
import { defer } from 'rxjs/observable/defer';


const defaultHeaders = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
};

const log = item => item;

export const fetchJsonCompat = (response) => {
  const json = () => Promise.resolve(response.data);
  return {
    ...response,
    json,
  };
};

export const getAuthHeaders = () => {
  const accessToken = window.localStorage.getItem('access_token');
  if (accessToken) {
    return {
      Authorization: `Bearer ${accessToken}`,
    };
  }
  return {};
};

export default class APIRequest {
  constructor(urlScheme, headers = { ...defaultHeaders }) {
    this.host = urlScheme.host;
    this.httpScheme = urlScheme.httpScheme;
    this.domainUrl = urlScheme.domainUrl;
    this.apiVersion = urlScheme.apiVersion;
    this.urlScheme = urlScheme;

    this.headers = headers;
    this.axios = Axios.create({
      baseURL: this.host,
      timeout: 10000,
    });
    this.interceptorsId = {
      response: [],
      request: [],
    };
  }


  fetch(config) {
    const {
      url,
      method = 'POST',
      headers = {},
      body = {},
      timeout = 10000,
      cancelToken,
      validateStatus = status => status >= 200 && status < 300,
    } = config;
    const headersBuild = {
      ...this.headers,
      ...headers,
      ...getAuthHeaders(),
    };
    const finalConfig = {
      url,
      method,
      headers: headersBuild,
      data: body,
      timeout,
      cancelToken,
      validateStatus,
      baseURL: this.host,
    };
    return this.axios
      .request(finalConfig)
      .then(fetchJsonCompat);
  }

  fetch$(config) {
    return defer(() => Observable.create((o) => {
      // console.log('fetch$');
      const source = Axios.CancelToken.source();
      o.add(() => {
        source.cancel('Cancel requested');
      });

      this.fetch({
        ...config,
        cancelToken: source.token,
      })
        .then((response) => {
          o.next(response);
          o.complete();
        })
        .catch((err) => {
          if (Axios.isCancel(err)) {
            log(err, 'RequestService Cancel error');
            o.complete();
          } else {
            o.error(err);
          }
        });
    }));
  }
}
